namespace RioERP.Products {
    export namespace ProductFranchiseeShareService {
        export const baseUrl = 'Products/ProductFranchiseeShare';

        export declare function Create(request: Serenity.SaveRequest<ProductFranchiseeShareRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductFranchiseeShareRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateShare(request: Serenity.SaveRequest<ProductFranchiseeShareRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductFranchiseeShareRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProductFranchiseeShareRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function DeleteShare(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImport(request: ExcelImportRequest, onSuccess?: (response: ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Products/ProductFranchiseeShare/Create",
            Update = "Products/ProductFranchiseeShare/Update",
            UpdateShare = "Products/ProductFranchiseeShare/UpdateShare",
            Delete = "Products/ProductFranchiseeShare/Delete",
            Retrieve = "Products/ProductFranchiseeShare/Retrieve",
            List = "Products/ProductFranchiseeShare/List",
            DeleteShare = "Products/ProductFranchiseeShare/DeleteShare",
            ExcelImport = "Products/ProductFranchiseeShare/ExcelImport"
        }

        [
            'Create', 
            'Update', 
            'UpdateShare', 
            'Delete', 
            'Retrieve', 
            'List', 
            'DeleteShare', 
            'ExcelImport'
        ].forEach(x => {
            (<any>ProductFranchiseeShareService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
